import Context from "../context/Context";

export function getHelperService(name) {
  const portal = Context.instance.portal;
  return portal && portal.helperServices && portal.helperServices[name];
}

export function getGeometryServiceUrl() {
  const service = getHelperService("geometry");
  return service && service.url;
}

export function project(geometry,outSR) {
  const promise = new Promise((resolve,reject) => {
    const lib = Context.instance.lib;
    const inSR = geometry.spatialReference;
    if (inSR.equals(outSR)) {
      resolve(geometry);
      return;
    }
    if (inSR.isWGS84 && outSR.isWebMercator) {
      const p = lib.esri.webMercatorUtils.geographicToWebMercator(geometry);
      resolve(p);
      return;
    }
    const url = getGeometryServiceUrl();
    if (!url) {
      reject(new Error("No geometry service url"));
      return;
    }
    const service = new lib.esri.GeometryService({
      url: url
    });
    const params = new lib.esri.ProjectParameters({
      geometries: [geometry],
      outSR: outSR
    });
    service.project(params).then((projected) => {
      resolve(projected[0]);
    }).catch(ex => {
      reject(ex);
    });

  });
  return promise;
}

export function projectToView(geometry,view) {
  return project(geometry,view.spatialReference);
}
